import React from 'react';

const FOOTER_ITEMS = [
  {
    label: 'Advertise',
    href: 'https://www.fastcompany.com/90516811/fast-company-mediakit',
    target: '_blank',
    rel: 'noopener noreferrer'
  },
  {
    label: 'Privacy Policy',
    href: 'https://www.fastcompany.com/privacy-policy',
    target: '_blank',
    rel: 'noopener noreferrer'
  },
  {
    label: 'Terms',
    href: '//www.mansueto.com/terms-of-service',
    target: '_blank',
    rel: 'noopener noreferrer'
  },
  {
    label: 'Notice of Collection',
    href: '//www.mansueto.com/privacy-policy/#collection',
    target: '_blank',
    rel: 'noopener noreferrer'
  },
  {
    label: 'Do Not Sell My Data',
    href: 'https://fastcompany.zendesk.com/hc/en-us/requests/new',
    target: '_blank',
    rel: 'noopener noreferrer'
  },
  {
    label: 'Permissions',
    href: 'https://kudos.fastcompany.com',
    target: '_blank',
    rel: 'noopener noreferrer'
  },
  {
    label: 'Help Center',
    href: 'https://www.fastcompany.com/contact-us'
  },
  {
    label: 'About Us',
    href: 'https://www.fastcompany.com/about-us'
  },
  {
    label: 'Site Map',
    href: '/sitemap'
  },
  {
    label: `Fast Company & Inc © ${new Date().getFullYear()} Mansueto Ventures, LLC`
  },
  {
    href: '//www.mansueto.com/vendor-policies',
    target: '_blank',
    rel: 'noopener noreferrer',
    labelOverride: (
      <img
        className="footer__daa-logo"
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAANCAAAAAC4QtCeAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAJ0Uk5TAAB2k804AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAAAEgAAABIAEbJaz4AAACASURBVAjXYyir3PaDAQby09KL9/2FcjIWf1mbVX0Mwklfw8DwbF5awzkwZzXDjco/j/vTuq+COe93APXcLE5bCeKczvzOwPCoPG0xiHMq6/f9SWkdF4HK1jKcyepJazgFNnrBpwtpVUchRuempR17+htqaU/55l9w5xzf+RHOBgC94zlXyQTR6wAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxMy0wMy0wOFQxOToxMDo0NC0wNTowMNnS5vEAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTMtMDMtMDhUMTk6MTA6NDQtMDU6MDCoj15NAAAAAElFTkSuQmCC"
        alt="Digital Advertising Alliance (DAA) Self-Regulatory Program"
        target="_new"
      />
    )
  }
];

const Footer = () => (
  <footer className="footer">
    <nav className="footer__nav-wrapper">
      <ul className="footer__link-container">
        {FOOTER_ITEMS.map((item, index) => {
          const { labelOverride, label, href, ...rest } = item;
          return (
            <li key={`footer-link-item-${index}`} className="footer__link">
              {href ? (
                <a href={href} {...rest}>
                  {labelOverride || label || ''}
                </a>
              ) : (
                <span {...rest}>{labelOverride || label || ''}</span>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  </footer>
);

export default Footer;
